module.exports = __webpack_public_path__ + "img/1503954723.7db4e24e.jpg";